import { factory, stateOptions } from '@store/utils'
import { prop } from 'rambda'

export default {
  auto: '*',

  store: {
    state: {
      types: [
        {
          label: 'Generate',
          value: 'GENERATE',
        },
        {
          label: 'Intro',
          value: 'INTRO',
        },
        {
          label: 'Spec',
          value: 'SPEC',
        },
        {
          label: 'Section',
          value: 'SECTION',
        },
        {
          label: 'Transform',
          value: 'TRANSFORM',
        },
      ],
    },

    getters: {
      promptTypes: prop('types'),

      promptFactory: factory(() => ({
        category: null,
        type: null,
        specTypeId: null,
        template: null,
      })),

      promptOptions: stateOptions(prop('name')),
    },
  },
}
